/* eslint-disable */
export default {
  '领蛋模块': {
    '我的头像': {
      'f_module': '领蛋模块',
      'f_resource': '我的头像',
      'f_type': 4
    },
    '活动规则按钮': {
      'f_module': '领蛋模块',
      'f_resource': '活动规则按钮',
      'f_type': 4
    },
    '页面浮动按钮': {
      'f_module': '领蛋模块',
      'f_resource': '页面浮动按钮',
      'f_type': 4
    },
    '按钮': function 按钮() {
      var data = {
        'f_module': '领蛋模块',
        'f_type': 4
      };
      var args = arguments;
      var f_resourceArr = ['', ''];
      data.f_resource = '';

      for (var i = 0; i < f_resourceArr.length; i++) {
        data.f_resource += f_resourceArr[i];

        if (i < f_resourceArr.length - 1) {
          data.f_resource += args[i];
        }
      }

      return data;
    }
  },
  '碰蛋获奖攻略': {
    '高等奖品做任务加蛋': {
      'f_module': '碰蛋获奖攻略',
      'f_resource': '高等奖品做任务加蛋',
      'f_type': 4
    },
    '普通奖品做任务加蛋': {
      'f_module': '碰蛋获奖攻略',
      'f_resource': '普通奖品做任务加蛋',
      'f_type': 4
    },
    '查看详细规则': {
      'f_module': '碰蛋获奖攻略',
      'f_resource': '查看详细规则',
      'f_type': 4
    }
  },
  '今日任务': {
    '任务': function 任务() {
      var data = {
        'f_module': '今日任务',
        'f_type': 4
      };
      var args = arguments;
      var f_resourceArr = ['', ''];
      data.f_resource = '';

      for (var i = 0; i < f_resourceArr.length; i++) {
        data.f_resource += f_resourceArr[i];

        if (i < f_resourceArr.length - 1) {
          data.f_resource += args[i];
        }
      }

      return data;
    }
  },
  '碰蛋记录': {
    '碰蛋战绩': {
      'f_module': '碰蛋记录',
      'f_resource': '碰蛋战绩',
      'f_type': 4
    },
    '获蛋记录': {
      'f_module': '碰蛋记录',
      'f_resource': '获蛋记录',
      'f_type': 4
    },
    '查看我的奖品': {
      'f_module': '碰蛋记录',
      'f_resource': '查看我的奖品',
      'f_type': 4
    }
  },
  '活动规则弹窗': {
    '我知道了': {
      'f_module': '活动规则弹窗',
      'f_resource': '我知道了',
      'f_type': 4
    }
  },
  '生成邀请好友弹窗': {
    '关闭x': {
      'f_module': '生成邀请好友弹窗',
      'f_resource': '关闭x',
      'f_type': 4
    }
  },
  '碰蛋弹框': {
    '不想碰': {
      'f_module': '碰蛋弹框',
      'f_resource': '不想碰',
      'f_type': 4
    },
    '和TA碰': {
      'f_module': '碰蛋弹框',
      'f_resource': '和TA碰',
      'f_type': 4
    },
    '算了': {
      'f_module': '碰蛋弹框',
      'f_resource': '算了',
      'f_type': 4
    },
    '做任务加蛋': {
      'f_module': '碰蛋弹框',
      'f_resource': '做任务加蛋',
      'f_type': 4
    },
    '我知道了': {
      'f_module': '碰蛋弹框',
      'f_resource': '我知道了',
      'f_type': 4
    }
  },
  '碰蛋结果弹框': {
    '继续碰蛋': {
      'f_module': '碰蛋结果弹框',
      'f_resource': '继续碰蛋',
      'f_type': 4
    },
    '查看我的奖品': {
      'f_module': '碰蛋结果弹框',
      'f_resource': '查看我的奖品',
      'f_type': 4
    },
    '我再试试': {
      'f_module': '碰蛋结果弹框',
      'f_resource': '我再试试',
      'f_type': 4
    }
  }
};